import axios, { endpoints } from 'src/utils/axios';

import { paths } from '../routes/paths';
import { CONFIG } from '../config-global';
import { setSession, STORAGE_KEY } from '../auth/context/jwt';

export const getAccessToken = () => localStorage.getItem('jwt_access_token');

export const tryToReLogin = () =>
  new Promise((resolve, reject) => {
    axios
      .post(`${endpoints.auth.refreshToken}`, null, {
        withCredentials: true,
        mode: 'cors',
        headers: {
          Accept: 'text/plain',
        },
      })
      .then((res) => {
        const accessToken = res.data;

        if (!accessToken) {
          throw new Error('Access token not found in response');
        }

        setSession(accessToken);
        resolve(true);
      })
      .catch((e) => {
        reject(e);
      });
  });

let refreshPromise = null;
let sessionExpired = false;

const refreshSession = () => {
  if (!refreshPromise) {
    refreshPromise = tryToReLogin().finally(() => {
      refreshPromise = null;
    });
  }
  return refreshPromise;
};

const responseSuccessHandler = (response) => response;
const responseErrorHandler = async (error) => {
  if (error?.response?.status === 401) {
    try {
      await refreshSession();
      const { config: oldRequest } = error;
      return await axios.request({
        ...oldRequest,
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
          'Content-Type': 'application/json',
        },
      });
    } catch (e) {
      if (e?.response?.status === 401 || e?.response?.status === 400 || e?.errorCode === 8) {
        // alert('Token expired!');
        if (!sessionExpired) {
          sessionExpired = true;
          localStorage.removeItem(STORAGE_KEY);
          window.location.href = paths.auth.jwt.signIn;
        }
        return Promise.reject(error);
      }
    }
  }
  return Promise.reject(error);
};

const getCustomResponse = (config) =>
  config.interceptors.response.use(
    (response) => responseSuccessHandler(response),
    async (error) => responseErrorHandler(error)
  );

export const getConfig = (type) => {
  const config = axios.create({
    baseURL: `${CONFIG.site.serverUrl}/${type}/api/v1/`,
  });
  config.defaults.headers.common.Authorization = `Bearer ${getAccessToken()}`;
  config.defaults.headers.post['Content-Type'] = 'application/json';

  getCustomResponse(config);
  return config;
};

export const backOfficeMicroservice = () => getConfig('backoffice');
export const configurationMicroservice = () => getConfig('Configuration');
